import { useCurrentUser } from "@/libs/apis/onboarding/useUser";
import { useIsDesktopOrHigher } from "@/libs/utils";
import InlineSvg from "@/src/components/InlineSvg";
import { ExternalLink } from "@/src/components/links/components/ExternalLink";
import { Label4 } from "@/src/components/typography/components/Label";
import React from "react";
import { TimelineProps } from ".";
import { useRedemptionModalContext } from "../UtilityTab/RedemptionModal/RedemptionModalContext";
import { use3DFileDownloadViewedAnalytics } from "../UtilityTab/hooks/analyticsHooks";
import { MINT_CHAIN_ID } from "@/libs/apis/onboarding/minting/constants";

type Props = Omit<TimelineProps, "description" | "legal">;

const Headline: React.FC<Props> = ({
  assetUrl,
  assetDescription,
  redemptionPeriod,
  label,
  ctaCopy,
  ownedBy,
  redemption,
  analyticsData,
}) => {
  const { currentUser } = useCurrentUser();
  const { isOpen, setIsOpen } = useRedemptionModalContext();
  const isDesktop = useIsDesktopOrHigher();
  const redeemNowClicked = use3DFileDownloadViewedAnalytics();

  const platform = redemption?.platforms && redemption?.platforms;
  const mobileCondition = !isDesktop && platform == "Mobile Only";
  const desktopCondition = isDesktop && platform == "Desktop Only";
  const bothCondition = platform == "Mobile and Desktop";

  const isOwnedByCurrentUser =
    currentUser && ownedBy === currentUser.swooshHandle;

  const onTimeLineCTAClicked = () => {
    redeemNowClicked({
      token: {
        tokenId: analyticsData.tokenId,
        name: analyticsData.tokenName,
        ownerHandle: ownedBy,
        isListed: false, // TODO: Update this when we have data coming from marketplace
      },
      collections: {
        name: analyticsData.collectionSlug,
        contractAddress: analyticsData.contractAddress,
        chainId: parseInt(MINT_CHAIN_ID), // chain Id does not change per env
        slug: analyticsData.collectionSlug,
      },
    });
    setIsOpen(!isOpen);
  };
  return (
    <div className="flex flex-wrap flex-col items-start justify-between">
      <div className=" flex flex-row items-center gap-5">
        <div className="flex">
          <InlineSvg
            asset={{ url: assetUrl, description: assetDescription }}
            className="w-9"
          />
        </div>
        <div>
          <Label4>{label}</Label4>
          <Label4 className="text-gray-350">{redemptionPeriod}</Label4>
          {isOwnedByCurrentUser &&
            (mobileCondition || desktopCondition || bothCondition) && (
              <ExternalLink
                size="sm"
                className="hover:cursor-pointer uppercase"
                onClick={onTimeLineCTAClicked}
              >
                {ctaCopy}
              </ExternalLink>
            )}
        </div>
      </div>
    </div>
  );
};

export default Headline;
